// extracted by mini-css-extract-plugin
export var title = "ProductGrid-module--title--UCKLF";